import styled from 'styled-components';

const Layout = styled.div`
  height: 100%;
`;

export const Wrapper = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;

export default Layout